export const buildFormData = (entries) => {
  const formData = new FormData();
  entries.forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });
  return formData;
};

export const buildDocumentUploadFormData = (file, userId) => (
  buildFormData([
    ["file", file],
    ["userId", userId]
  ])
);

export const buildFileLookupCriteria = (bucketName, userId) => ({
  bucketName,
  userId
});
